import { TenantContext } from '../models/types';

export const mockTenantContext: TenantContext = {
  tenantId: '11111111-1111-1111-1111-111111111111',
  tenantName: 'Fabrikam Research',
  userEmail: 'admin@fabrikam.example.com',
  environment: 'dev',
  subscriptionSource: 'Microsoft Marketplace',
  planCode: 'standard',
  coveredTenantCount: 1,
  isMultiTenantCoverage: false,
  capabilities: {
    canUseCustomerSelfService: true,
    canManageInstallations: true,
    canDeploySpfx: true,
    canSelectTenantScope: true,
    canManageScopes: true,
    canManageAiPolicy: true,
    canReviewAiUsage: true,
    canManagePiiPolicy: true,
    canUseCapa: true,
    canManageCapaAssignments: true,
    canUseRisk: true,
    canManageSupplierCollaboration: true,
    canUseSupplierCollaboration: true,
    canManagePermissions: true,
    canManageClientAccounts: true,
    canManageMarketing: true,
    canManageSplashContent: true,
    canManageEvidence: true,
    canManageStaffRoles: true,
    canUseInspector: true
  },
  authority: {
    isStaffAdmin: true,
    isCustomerAdmin: true,
    customerAuthorityReason: 'subscription_contact',
    coveredTenantIds: ['11111111-1111-1111-1111-111111111111']
  },
  roles: ['EdinshallEmployee', 'GlobalAdmin'],
  entitlements: ['PlatformAccess'],
  productsOwned: [
    {
      id: 'audit',
      name: 'Edinshall Audit',
      status: 'Active',
      features: ['audit-management', 'tenant-dashboard'],
      deepLinks: {
        launch: 'https://tenant.sharepoint.com/sites/edinshall-audit',
        documentation: '/docs?path=docs/documentation/developers/architecture-guide.md',
        adminGuide: '/docs?path=docs/documentation/admins/operations-guide.md',
        support: '/support'
      }
    }
  ]
};
